export default __webpack_public_path__ + "static/SR USA - Hoja de Seguridad - Color Caramelo (Polvo)-71d88be7d03b1d2af09c99c90caab6e9.pdf";